import * as _ from 'lodash';

import axiosInstance from '../../../axiosInstance';
import { setShowAlert } from '../../utilts/utilsSlice';
import { TOAST_TYPE } from '../../../utils/constantTypes';
import {
  AdminWritebackRecoveryPayloadType,
  AdminWritebackRecoveryResponseType,
  DeleteTrialUsersReportsPayloadType,
  GetActiveUsersSummaryPayloadType,
  GetAdminAppointmentsPayloadType,
  GetAdminAppointmentsResponseType,
  GetReportsByFilterPayloadType,
  GetReportWritebackFailureAnalysisPayloadType,
  GetAdminReportFilesPayloadType
} from '../../report/interfaces/index';

export const getReportsByFilters = async (
  payload: GetReportsByFilterPayloadType,
  { dispatch }
) => {
  try {
    const res = await axiosInstance.get('report/all', {
      params: { ...payload?.filters },
      headers: {
        Authorization: `Bearer ${payload?.accessToken}`
      }
    });
    return res?.data;
  } catch (err) {
    if (err?.response?.data?.statusCode !== 401) {
      dispatch(
        setShowAlert({
          show: true,
          message:
            err?.response?.data?.msg ||
            'An error occurred while fetching reports.',
          type: TOAST_TYPE.ERROR
        })
      );
    }
    throw new Error(
      err?.response?.data?.msg || 'An error occurred while fetching reports.'
    );
  }
};

export const getActiveUsersSummary = async (
  payload: GetActiveUsersSummaryPayloadType,
  { dispatch }
) => {
  try {
    const res = await axiosInstance.get('report/active-users-reports-summary', {
      params: {
        startDate: payload?.data?.startDate,
        endDate: payload?.data?.endDate
      },
      headers: {
        Authorization: `Bearer ${payload?.accessToken}`
      }
    });
    return res?.data;
  } catch (err) {
    if (err?.response?.data?.statusCode !== 401) {
      dispatch(
        setShowAlert({
          show: true,
          message:
            err?.response?.data?.msg ||
            'An error occurred while fetching active users summary.',
          type: TOAST_TYPE.ERROR
        })
      );
    }
  }
};

export const hardDeleteReportsByAppoitmentIds = async (
  payload: DeleteTrialUsersReportsPayloadType,
  { dispatch }
) => {
  try {
    const res = await axiosInstance.delete('user/trial-user/reports', {
      data: {
        appointmentIds: [...(payload?.data?.appointmentIds || [])]
      },
      headers: {
        Authorization: `Bearer ${payload?.accessToken}`
      }
    });
    return res?.data;
  } catch (err) {
    if (err?.response?.data?.statusCode !== 401) {
      dispatch(
        setShowAlert({
          show: true,
          message:
            err?.response?.data?.msg ||
            'An error occurred while delete reports.',
          type: TOAST_TYPE.ERROR
        })
      );
    }
    throw new Error(
      err?.response?.data?.msg || 'An error occurred while delete reports.'
    );
  }
};

export const getReportWritebackAnalysis = async (
  payload: GetReportWritebackFailureAnalysisPayloadType,
  { dispatch }
) => {
  try {
    const res = await axiosInstance.post(
      'report/writeback-analysis',
      {
        ...payload?.data
      },
      {
        headers: {
          Authorization: `Bearer ${payload?.accessToken}`
        }
      }
    );
    return res?.data;
  } catch (err) {
    // if (err?.response?.data?.statusCode !== 401) {
    //   dispatch(
    //     setShowAlert({
    //       show: true,
    //       message:
    //         err?.response?.data?.msg ||
    //         'An error occurred while fetching report writeback analaysis.',
    //       type: TOAST_TYPE.ERROR
    //     })
    //   );
    // }
    throw new Error(
      err?.response?.data?.msg ||
        'An error occurred while fetching report writeback analaysis.'
    );
  }
};

export const getAdminAppointments = async (
  payload: GetAdminAppointmentsPayloadType,
  { dispatch }
): Promise<GetAdminAppointmentsResponseType> => {
  try {
    const res = await axiosInstance.get('report/admin/appointments', {
      params: {
        officeId: payload?.data?.officeId,
        date: payload?.data?.date
      },
      headers: {
        Authorization: `Bearer ${payload?.accessToken}`
      }
    });
    return res?.data;
  } catch (err) {
    if (err?.response?.data?.statusCode !== 401) {
      dispatch(
        setShowAlert({
          show: true,
          message:
            err?.response?.data?.msg ||
            'An error occurred while fetching appointments.',
          type: TOAST_TYPE.ERROR
        })
      );
    }
    throw new Error(
      err?.response?.data?.msg ||
        'An error occurred while fetching appointments.'
    );
  }
};

export const getAdminReportFiles = async (
  payload: GetAdminReportFilesPayloadType,
  { dispatch }
) => {
  try {
    const res = await axiosInstance.post(
      'admin/report-files',
      {
        ...payload?.data
      },
      {
        headers: {
          Authorization: `Bearer ${payload?.accessToken}`
        }
      }
    );
    return res?.data;
  } catch (err) {
    if (err?.response?.data?.statusCode !== 401) {
      dispatch(
        setShowAlert({
          show: true,
          message:
            err?.response?.data?.msg ||
            'An error occurred while fetching report files.',
          type: TOAST_TYPE.ERROR
        })
      );
    }
    throw new Error(
      err?.response?.data?.msg ||
        'An error occurred while fetching report files.'
    );
  }
};

export const queueAdminWritebackRetry = async (
  payload: AdminWritebackRecoveryPayloadType,
  { dispatch }
): Promise<AdminWritebackRecoveryResponseType> => {
  try {
    const res = await axiosInstance.post(
      'report/admin/writeback-retry',
      {
        ...payload?.data
      },
      {
        headers: {
          Authorization: `Bearer ${payload?.accessToken}`
        }
      }
    );
    return res?.data;
  } catch (err) {
    if (err?.response?.data?.statusCode !== 401) {
      dispatch(
        setShowAlert({
          show: true,
          message:
            err?.response?.data?.msg ||
            'An error occurred while queueing the writeback retry.',
          type: TOAST_TYPE.ERROR
        })
      );
    }
    throw new Error(
      err?.response?.data?.msg ||
        'An error occurred while queueing the writeback retry.'
    );
  }
};
